module.exports = __webpack_public_path__ + "img/logo-tl-mobil-dark.ade86882.svg";